"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var common_1 = require("@scuf/common");
var localization_1 = require("@scuf/localization");
var ActionBarRender = /** @class */ (function (_super) {
    __extends(ActionBarRender, _super);
    function ActionBarRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionBarRender.prototype.render = function () {
        var _a = this.props, context = _a.context, children = _a.children, clearSelectionOnClose = _a.clearSelectionOnClose;
        return (React.createElement("div", { className: "action-bar" },
            React.createElement("div", { className: "totals" },
                React.createElement("span", { className: "total-value" },
                    context.total,
                    " ",
                    React.createElement(localization_1.Translation, { transKey: "Total" })),
                (context.selectionMode && context.selectionMode === 'multiple') && React.createElement("span", { className: "selected-value" },
                    context.selections,
                    " ",
                    React.createElement(localization_1.Translation, { transKey: "Selected" }))),
            React.createElement("div", { className: "menu-items" },
                children,
                React.createElement("div", { className: "close-btn", onClick: function () {
                        if (context.toggle) {
                            context.toggle(clearSelectionOnClose);
                        }
                    } },
                    React.createElement(common_1.Icon, { name: "close", root: "common", className: "close-btn-icon", size: "small" })))));
    };
    return ActionBarRender;
}(React.Component));
exports.default = ActionBarRender;
//# sourceMappingURL=ActionBarRender.js.map